export const NotificationEndpoints = {
  getMyActions: process.env['NEXT_PUBLIC_API'] + '/notifications/actions',
  getMyUpdates: process.env['NEXT_PUBLIC_API'] + '/notifications/updates',
  getMyNewNotifications: process.env['NEXT_PUBLIC_API'] + '/notifications',
  getAdminNewNotifications:
    process.env['NEXT_PUBLIC_API'] + '/teachers/notifications',
  markNotificationAsRead: (notificationId: string) =>
    process.env['NEXT_PUBLIC_API'] + `/notifications/${notificationId}/read`,
  markNotificationStackAsRead:
    process.env['NEXT_PUBLIC_API'] + `/notifications/mark-as-read`,
  markAdminNotificationAsRead: (notificationId: string) =>
    process.env['NEXT_PUBLIC_API'] +
    `/teachers/notifications/${notificationId}/read`,
  markAdminNotificationStackAsRead:
    process.env['NEXT_PUBLIC_API'] + `/teachers/notifications/mark-as-read`,
};
